// eslint-disable-next-line no-shadow
export enum CanvasLoraLocalCategories {
	ALL = 'All',
}
